import _ from 'lodash';
import packageJson from '../../package.json';

/**
 * 判断当前环境是不是web端
 *
 * @returns
 */
export const isWeb = () => {
    return !_.has(window, `window.MbApi.file`);
};

export const isForExt = () => {
    let result = false;
    /* global FOREXT */
    if (typeof FOREXT !== 'undefined' && FOREXT === true) {
        result = true;
    }
    return result;
};

export const isLocal = () => {
    let remoteHost = [
        'test.ide.makeblock.com',
        'testide.makeblock.com',
        'ide.makeblock.com',
        'ext.mblock.makeblock.com',
        'ide.mblock.cc',
        'testide.mblock.cc'
    ];
    let host = window.location.host;
    let local = remoteHost.indexOf(host) === -1;
    return local;
};

export const getVendorPrefix = () => {
    var body = document.body || document.documentElement,
        style = body.style,
        vendor = ['webkit', 'khtml', 'moz', 'ms', 'o'],
        i = 0;

    while (i < vendor.length) {
        if (typeof style[vendor[i] + 'Transition'] === 'string') {
            return vendor[i];
        }
        i++;
    }
};

export const isWebkit = () => {
    return getVendorPrefix() === 'webkit';
};

export const isChrome = () => {
    const userAgent = navigator.userAgent.toLocaleLowerCase();
    return (userAgent.indexOf('chrome') > -1 || userAgent.indexOf('crios') > -1) && userAgent.indexOf('safari') > -1;
};

/* globals APP_VERSION */
export const getVersion = () => {
    let version = APP_VERSION;
    return version;
};

/* 内部构建版本号，会严格递增 */
export const getBuildVersion = () => {
    let version = packageJson.version;
    return version;
};

/* 根据域名判断是国际还是国内ide */
export const isInternational = () => {
    if(isLocal()) {
        return true;
    }
    const host = window.location.host;
    if(host.indexOf('mblock.cc') !== -1) {
        return true;
    }
    return false;
};

export const getInternational = () => {
    if(isInternational()) {
        return 'en';
    }
    return 'zh';
};